/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MagnetCreationData } from '../../models/magnet-creation-data';

export interface VaultCreateVaultMagnet$Params {

/**
 * GUID of the vault
 */
  vaultId: string;
  
    /**
     * Magnet creation data
     */
    body?: MagnetCreationData
}

export function vaultCreateVaultMagnet(http: HttpClient, rootUrl: string, params: VaultCreateVaultMagnet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, vaultCreateVaultMagnet.PATH, 'post');
  if (params) {
    rb.path('vaultId', params.vaultId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

vaultCreateVaultMagnet.PATH = '/vault/{vaultId}/magnet';
